<template>
  <app-layout>
    <dashboard-layout>
      <template slot="footer-row">
        <v-container class="pt-1">
          <v-layout row wrap>
            <v-flex md12>
              <v-card class="pa-4">
                <v-card-title primary-title>
                  <v-container class="pa-0">
                    <v-flex md12>
                      <h1 class="club-title">{{ $t('CLUB REBELDE') }}</h1>
                    </v-flex>
                    <v-flex md12>
                      <h3 class="club-subtitle">
                        {{
                          $t(
                            'Aprovecha las ventajas del Club Rebelde. Ponemos a tu disposición un Club de beneficios que te brinda descuentos y privilegios en renting de vehículos, seguros, suministros, y mucho más.',
                          )
                        }}
                      </h3>
                    </v-flex>
                  </v-container>
                </v-card-title>
              </v-card>
            </v-flex>
            <v-flex md12>
              <hr class="mt-3 mb-3" style="border: solid 1px #FFB01E" />
            </v-flex>
            <v-flex md12>
              <h2>{{ $t('DESTACADOS') }}</h2>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <template v-for="(item, index) in featuredPartners">
              <v-flex md6 :key="index">
                <router-link :to="item.alias" style="text-decoration: none">
                  <v-card>
                    <v-list two-line class="pa-4">
                      <template>
                        <v-list-tile :key="item.title" avatar>
                          <v-list-tile-avatar class="v-custom-avatar">
                            <img :src="item.featured_logo" alt="" />
                          </v-list-tile-avatar>

                          <v-list-tile-content class="v-custom-content">
                            <v-list-tile-title v-html="item.featured_title"></v-list-tile-title>
                            <v-list-tile-sub-title
                              v-html="item.featured_subheader"
                            ></v-list-tile-sub-title>
                          </v-list-tile-content>

                          <v-list-tile-action>
                            <v-btn icon ripple>
                              <v-icon color="grey lighten-1">arrow_right</v-icon>
                            </v-btn>
                          </v-list-tile-action>
                        </v-list-tile>
                      </template>
                    </v-list>
                  </v-card>
                </router-link>
              </v-flex>
            </template>
          </v-layout>
        </v-container>
        <v-container>
          <v-layout row wrap>
            <v-flex md12>
              <h2>{{ $t('PARTNERS') }}</h2>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <template v-for="(item, index) in partners">
              <v-flex md4 sm4 :key="index">
                <router-link :to="item.alias" style="text-decoration: none">
                  <v-card class="" height="200">
                    <v-layout align-center justify-center fill-height class="pa-4">
                      <v-layout row wrap>
                        <v-flex xs12 class="text-xs-center">
                          <v-icon color="primary icon-partner">{{ item.icon }}</v-icon>
                        </v-flex>
                        <v-flex xs12 class="text-xs-center">
                          <span class="partner-title">{{ item.title }}</span>
                        </v-flex>
                        <v-flex xs12 class="text-xs-center">
                          <span class="partner-subtitle">{{ item.subheader }}</span>
                        </v-flex>
                      </v-layout>
                    </v-layout>
                  </v-card>
                </router-link>
              </v-flex>
            </template>
          </v-layout>
        </v-container>
      </template>
      <template slot="sidebar">
        <v-flex md12>
          <my-consultant-conversation></my-consultant-conversation>
        </v-flex>
        <v-flex md12 pt-3>
          <calendar-events></calendar-events>
        </v-flex>
      </template>
    </dashboard-layout>
    <router-view></router-view>
  </app-layout>
</template>

<script>
import AppLayout from '@/views/layouts/AppLayout.vue';
import DashboardLayout from '@/views/layouts/DashboardLayout.vue';
import MyConsultantConversation from '@/modules/myconsultant/components/threads/MyConsultantConversation.vue';
import CalendarEvents from '@/modules/calendar/components/CalendarEvents.vue';
import apiCtrl from '@/services/api/abstract/abstract-api.js';

export default {
  components: {
    AppLayout,
    CalendarEvents,
    MyConsultantConversation,
    DashboardLayout,
  },

  data: () => ({
    featuredPartners: [],
    partners: [],
  }),

  mounted() {
    this.getPartners();
  },

  methods: {
    markDocNotificationsAsReaded(category) {
      const body = {
        category: category,
      };
      apiCtrl.post('/document-notification/mark-as-readed', body).then(res => {
        console.log(res);
      });
    },
    getPartners() {
      this.loading = true;
      const config = {
        params: {},
      };
      apiCtrl
        .get('/club-space', config)
        .then(res => {
          this.featuredPartners = res.data.data.filter(item => item.featured);
          this.partners = res.data.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
          // this.showSnackMessage(
          //   'error',
          //   'Se ha producido un error al cargar las obligaciones fiscales',
          // );
        });
    },
  },
};
</script>
<style scoped>
.club-title {
  font-size: 2rem;
}
.club-subtitle {
  font-size: 1.2rem;
  font-weight: 400;
  max-width: 80%;
}
.v-custom-avatar div {
  height: 75px !important;
  width: 75px !important;
}
.v-custom-content {
  margin-left: 20px !important;
}
.v-custom-content .v-list__tile__title {
  font-weight: bold !important;
  font-size: 1.2rem;
}
.v-custom-content .v-list__tile__sub-title {
  color: grey;
  font-size: 1rem;
}
.text--icon-partner {
  font-size: 3rem !important;
}
.partner-title {
  font-size: 1.2rem;
  color: black;
  font-weight: bold;
}
.partner-subtitle {
  font-size: 1rem;
  color: grey;
}
</style>
